var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('banner'),_vm._v(" "),_c('block-title',{attrs:{"title":"线上场景"}}),_vm._v(" "),_c('online'),_vm._v(" "),_c('block-title',{staticClass:"offline-scene",attrs:{"title":"线下场景"}}),_vm._v(" "),_c('offline'),_vm._v(" "),_c('text-message-banner'),_vm._v(" "),_c('direct-user-banner'),_vm._v(" "),_c('get-more')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b402526","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantage/Advantage.vue
// module id = null
// module chunks = 